export { useAscWagesRedirect } from './useAscWagesRedirect';
